module.exports = "<script type=\"text/html\" id=\"survey-timerpanel\">\n    <div data-bind=\"text:koTimerInfoText\"></div>\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/templates/timerpanel.html
// module id = 123
// module chunks = 0